// extracted by mini-css-extract-plugin
export var cartContainer = "_p4-4";
export var gray = "_p4-1";
export var itemContainer = "_p4-2";
export var itemDetails = "_p4-3";
export var strong = "_p4-0";